module.exports = __webpack_public_path__ + "img/ios-download.6a37459a.png";